export default __webpack_public_path__ + "static/media/ajax-loader.52e7c57b.svg";